// extracted by mini-css-extract-plugin
module.exports = {"tagField":"style__tagField__RipVW","addBtn":"style__addBtn__I3fjA","thumbnail":"style__thumbnail__n-aiW","actions":"style__actions__nPFGs","tags":"style__tags__YeVmY"};